import { useId } from 'react';
import { useTheme, type ThemePreference } from '@/hooks/useTheme';
import { IconMonitor, IconMoon, IconSun } from './Icons';

const OPTIONS: { value: ThemePreference; label: string; icon: JSX.Element }[] = [
  { value: 'light', label: 'Claro', icon: <IconSun /> },
  { value: 'dark', label: 'Escuro', icon: <IconMoon /> },
  { value: 'system', label: 'Igual ao sistema', icon: <IconMonitor /> },
];

/**
 * Seletor de tema em rádios nativos: as setas do teclado trocam a opção sem
 * código extra, e o leitor de tela anuncia o grupo e a escolha atual.
 *
 * O nome do grupo é único por instância: o layout desenha um seletor na barra
 * lateral e outro na barra do celular, e rádios com o mesmo `name` formam um
 * grupo só no documento inteiro — um desmarcaria o outro.
 */
export function ThemeToggle() {
  const { preference, setPreference } = useTheme();
  const name = useId();

  return (
    <fieldset className="theme-toggle">
      <legend className="sr-only">Tema da interface</legend>
      {OPTIONS.map((option) => (
        <label key={option.value} className="theme-toggle-option" title={option.label}>
          <input
            type="radio"
            name={name}
            value={option.value}
            checked={preference === option.value}
            onChange={() => setPreference(option.value)}
            className="sr-only"
          />
          {option.icon}
          <span className="sr-only">{option.label}</span>
        </label>
      ))}
    </fieldset>
  );
}
